<div #logsContainer class="process-logs-container">
  @for (log of logs(); track $index) {
    <div class="process-logs-item" innerHTML="{{ log }}"></div>
  }
</div>
